export default ({ features }) => {
  if (!features?.length) return [];
  const thresholds = [];
  features.forEach((gauge) => {
    thresholds.push({ ...gauge.properties, gauge_id: gauge.properties.site_id, watershed: gauge.properties.Watershed, name: gauge.properties.HCFCD_name });
  });
  return thresholds;
};
